
import {
  defineComponent, PropType,
} from 'vue';
import { ManagementFrameTitleItem } from './js/types';
import managementFrameTitleFun from './js/managementFrameTitle';

export default defineComponent({
  components: {},
  emits: ['click'],
  props: {
    items: {
      type: Array as PropType<ManagementFrameTitleItem[]>,
      default: [],
    },
    currentIndex: {
      type: Number,
      default: undefined,
    },
  },
  setup(props, { emit }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const managementFrameTitle = managementFrameTitleFun(props as any, emit, 'click');
    return {
      managementFrameTitle,
    };
  },
});
